import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import TriggerUsersTable from './TriggerUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyTriggerUsers } from './companyTriggerApi';

/**
 * Company Trigger Trace → Employees/Members list.
 *
 * Adoption only. Rows do not open, because there is nothing behind them that
 * could be shown without attaching somebody's private reflection to their name.
 */
const CTriggerUsers = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    (params) => fetchCompanyTriggerUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trigger Trace — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and how much they have used Trigger Trace.
        Counts and dates only — what anybody logged, how it felt or how hard it hit is never shown
        beside a name, and there is no page behind these rows.
      </p>

      <TriggerUsersTable fetcher={fetcher} tableName="company_trigger_users" />
    </div>
  );
};

export default CTriggerUsers;
